import { gsap } from 'gsap';

export default {
	name: 'default',
	before({ current, next, trigger }) {
		document.body.classList.add('body--transitioning');

		return new Promise((resolve) => {
			gsap.to(current.container, {
				opacity: 0,

				ease: 'none',
				duration: 0.5,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	afterLeave({ current, next, trigger }) {
		gsap.set(next.container, {
			opacity: 0,
		});
		current.container.classList.add('barba-container--absolute');
	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(next.container, {
				opacity: 1,

				ease: 'none',
				duration: 0.5,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	after({ current, next, trigger }) {
		document.body.classList.remove('body--transitioning');
		if (window.sbi_init) {
			window.sbi_init();
		}
	},
};
